export default class Config {
  static get apiBaseUrl () {
    if (process.env.NODE_ENV === 'development') return 'http://localhost:8085'
    return 'https://strates-vs.crealp.ch/datalake-api'
  }

  static get authBaseUrl () {
    if (process.env.NODE_ENV === 'development') return 'http://localhost:8086'
    return 'https://strates-vs.crealp.ch/mgmt-api'
  }

  static get basePath () {
    if (process.env.NODE_ENV === 'development') return '/'
    return '/datalake/'
  }
}
